export default __webpack_public_path__ + "static/media/background.ec14c50c.jpg";